<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="25rem"
  >
    <template v-slot:activator="{ on }">
      <v-btn small text v-on="on">
        <v-icon small left>
          fa-search
        </v-icon>
        Rechercher
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="pa-1">
        <v-row dense no-gutters align="start" justify="end">
          <v-btn small icon text @click="dialog = !dialog">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" @submit.prevent="search">
          <v-autocomplete
            ref="input"
            dense
            filled
            class="no-before"
            :items="filteredProduct"
            item-value="nom"
            item-text="nom"
            v-model="productName"
            label="Nom du produit"
            required
          >
            <template v-slot:selection="data">
              <span class="text-capitalize">{{ data.item.nom }}</span>
            </template>
            <template v-slot:item="data">
              <span class="text-capitalize">{{ data.item.nom }}</span>
            </template>
          </v-autocomplete>
        </v-form>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-row align="center" justify="end" dense no-gutters>
          <v-btn
            :disabled="valid === false"
            small
            color="success"
            @click="search"
          >
            Rechercher
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { mappers } from "@/mappers";
export default {
  name: "InventoryTemplateEditorSearch",
  props: {
    tags: {
      requried: true
    }
  },
  computed: {
    ...mapGetters(["getProducts"]),
    filteredProduct() {
      return this.getProducts.filter(
        x =>
          x.data !== null &&
          this.tags.some(t =>
            x.data.tags
              .map(tag => mappers.normalize(tag))
              .includes(mappers.normalize(t))
          )
      );
    }
  },
  data() {
    return {
      productName: undefined,
      dialog: false,
      valid: false
    };
  },
  methods: {
    search() {
      this.$emit("search", this.productName);
      this.dialog = false;
    }
  },
  watch: {
    dialog(v) {
      if (v === false) {
        setTimeout(() => this.$refs.form.reset(), 100);
      } else {
        setTimeout(() => this.$refs.input.focus(), 100);
      }
    }
  }
};
</script>

<style></style>
